import React from 'react';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../header/Header';
import { useSelector } from 'react-redux';
import { selectLoader } from 'src/app/selectors/filterSelectors';
import Spinner from '../Spinner/Spinner';
import { selectInitLoader } from 'src/app/selectors/appDataSelectors';

const AppLayout = ({
  children,
  toggleTheme,
  themeMode,
}: {
  children: React.ReactNode;
  toggleTheme: () => void;
  themeMode: 'light' | 'dark';
}) => {
  const sidebarWidth = 240; // adjust based on your collapsed/expanded sidebar widths
  const isLoading = useSelector(selectLoader);
  const isInit = useSelector(selectInitLoader);

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <Sidebar />

      {/* Main content area */}
      <div
        className="flex-grow"
        style={{ width: `calc(100vw - ${sidebarWidth}px)`, 
        overflowX: 'auto',
        overflowY: 'auto' }}
      >
        {/* Header */}
        <Header themeMode={themeMode} toggleTheme={toggleTheme} />
        {/* Content */}
        <main className="p-1" style={{minWidth: 'fit-content'}}>{children}</main>{' '}
        {/* Content pushed down to account for header */}
        {(isLoading || !isInit) && <Spinner />}
      </div>
    </div>
  );
};

export default AppLayout;
